export default __webpack_public_path__ + "static/media/aws-cp.22b1cfaa.png";